import { BudgetAllocationInput } from '../../lib/types/models/budget-line/budget-allocation-input'
import { BudgetLine } from '../../lib/types/models/budget-line/budget-line'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createBudgetAllocation(data: BudgetAllocationInput) {
  return restApiClient
    .url(constructApiUrl(API.budgetAllocation.create.url, null))
    .post<BudgetLine, BudgetAllocationInput>(data)
}
